// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2sufh","left":"InfoRow_left__2mEiL"};